import { AnyAnimatableProperty } from '@figmotion/figmotion-animation-data';

export const BetaUserOnlyProperties: AnyAnimatableProperty[] = [];
